import {
    Component,
    OnInit,
    Input,
    ChangeDetectorRef,
    ViewChild,
    ElementRef,
    Renderer2,
    HostListener
} from '@angular/core';
import { Router, ActivatedRoute, NavigationStart } from '@angular/router';
import { ErrorStateMatcher } from '@angular/material/core';
import {
    UntypedFormGroup,
    UntypedFormBuilder,
    AbstractControl,
    UntypedFormControl,
    FormGroupDirective,
    NgForm,
    Validators
} from '@angular/forms';
import { UserInterface } from 'src/app/model/user/user-interface';
import { DialogService } from 'src/app/services/dialog-service/dialog-service.service';
import { HeaderServiceService } from 'src/app/services/header-service/header-service.service';
import { UtilService } from 'src/app/services/util-service/utilService';
import { GENDERS, TITLES } from 'src/environments/constants';
import { VALIDATORS } from 'src/environments/validators';
import { RegistrationService } from 'src/app/services/registration-service/registration.service';
import { UserLocalSelectionService } from 'src/app/services/dataServices/user-local-selection-service/user-local-selection.service';
import { filter } from 'rxjs/operators';

// self-defined ErrorStateMatcher - required to validate password-confirm
export class registryErrorStateMatcher implements ErrorStateMatcher {
    isErrorState(
        control: UntypedFormControl | null,
        form: FormGroupDirective | NgForm | null
    ): boolean {
        const invalidCtrl = !!(
            control &&
            control.invalid &&
            control.parent.dirty
        );
        const invalidParent = !!(
            control.value !== control.parent.value.password &&
            control.parent.invalid
        );
        return invalidCtrl || invalidParent;
    }
}

@Component({
    selector: 'app-registry-page',
    templateUrl: './registry-page.component.html',
    styleUrls: ['./registry-page.component.css'],
    standalone: false
})
export class RegistryPageComponent implements OnInit {
    @ViewChild('passwordField') private passwordField: ElementRef;
    @ViewChild('passwordFieldConfirm') private passwordFieldConfirm: ElementRef;

    public arePasswordRulesVisible: boolean = false;
    // FromGroup of registry form
    registryForm: UntypedFormGroup;

    // ErrorStateMatcher - Class defined above
    matcher = new registryErrorStateMatcher();

    // controlls of registry form
    email: AbstractControl;
    gender: AbstractControl;
    title: AbstractControl;
    firstname: AbstractControl;
    lastname: AbstractControl;
    password: AbstractControl;
    confirmpassword: AbstractControl;
    phoneNumber: AbstractControl;
    // website: AbstractControl;
    // position: AbstractControl;

    code: String;
    inviteCode: string;
    invitedUserName: string = '';
    registerClicked: boolean = false;
    registerWithInvite: boolean = false;
    public isSpecialInvite: boolean | null = null;
    loading: boolean = false;

    // user object to handle registry easier
    private newUser: UserInterface = {
        userName: '',
        password: '',
        firstName: '',
        lastName: '',
        email: '',
        gender: '',
        // phoneNumber: '',
        // mobileNumber: '',
        title: '',
        organisationDto: {
            organisationName: '',
            website: '',
            address: { city: '', postalCode: '', street: '' }
        }
    };

    passwordStrength = 0;
    passwordTouched = false;
    showPassword = false;

    passwordCriteria = {
        length: false,
        uppercase: false,
        lowercase: false,
        number: false,
        specialChar: false,
        noWhitespace: false
    };

    rsaEncrypt;

    @Input()
    providers;

    private shouldClearSelPackage = true;
    private routerSubscription;

    public genders = GENDERS;
    public titles = TITLES;
    private clickListener: () => void;

    constructor(
        private router: Router,
        private registrationService: RegistrationService,
        private dialogService: DialogService,
        private utilService: UtilService,
        private headerService: HeaderServiceService,
        private route: ActivatedRoute,
        fb: UntypedFormBuilder,
        private cd: ChangeDetectorRef,
        private renderer: Renderer2,
        private localSelectionService: UserLocalSelectionService
    ) {
        // building registryForm and adding validators
        this.registryForm = fb.group(
            {
                email: ['', VALIDATORS.email],
                gender: [''],
                title: [''],
                firstname: ['', VALIDATORS.firstname],
                lastname: ['', VALIDATORS.lastname],
                // phoneNumber: ['', Validators.pattern(/^\+?[\d\s]{10,20}$/)],
                password: ['', VALIDATORS.password],
                confirmpassword: [''],
                termsAccepted: [false, Validators.requiredTrue],
                terms2Accepted: [false, Validators.requiredTrue],
                terms3Accepted: [false],
                // website: ['', VALIDATORS.website],
                // position: ['', VALIDATORS.position]
            },
            { validator: VALIDATORS.registryForm }
        );
        this.email = this.registryForm.controls['email'];
        this.gender = this.registryForm.controls['gender'];
        this.title = this.registryForm.controls['title'];
        this.firstname = this.registryForm.controls['firstname'];
        this.lastname = this.registryForm.controls['lastname'];
        // this.phoneNumber = this.registryForm.controls['phoneNumber'];
        this.password = this.registryForm.controls['password'];
        this.confirmpassword = this.registryForm.controls['confirmpassword'];
        // this.website = this.registryForm.controls['website'];
        // this.position = this.registryForm.controls['position'];
    }

    ngAfterViewInit() {
        this.clickListener = this.renderer.listen('window', 'click', (e: Event) => {
            if (
                e.target === this.passwordField.nativeElement ||
                this.passwordField.nativeElement.contains(e.target) ||
                e.target === this.passwordFieldConfirm.nativeElement ||
                this.passwordFieldConfirm.nativeElement.contains(e.target)
            ) {
                this.arePasswordRulesVisible = true;
            } else {
                this.arePasswordRulesVisible = false;
            }
            this.cd.detectChanges();
        });
    }

    @HostListener('window:beforeunload')
    onBeforeUnload() {
        // Delets Data if tab was closed
        this.localSelectionService.clearSelection('selectedPackage-register');
    }

    showContractTransfer() {
        this.dialogService.openContractTransferDialogInform('Schließen');
    }

    showAgb() {
        this.dialogService.openAgbDialogInform('Schließen');
    }

    showPrivacy() {
        this.dialogService.openPrivacyDialogInform('Schließen');
    }

    // on registry press
    onSubmit() {
        this.registerClicked = true;
        if (
            this.utilService.isStringNullOrEmpty(this.firstname.value) ||
            this.utilService.isStringNullOrEmpty(this.lastname.value) ||
            this.utilService.isStringNullOrEmpty(this.email.value) ||
            this.utilService.isStringNullOrEmpty(this.password.value) ||
            this.password.value != this.confirmpassword.value
        ) {
            this.dialogService.openDialog(
                'Es ist ein Fehler aufgetreten',
                'Bitte füllen Sie alle Felder korrekt aus'
            );
            this.registerClicked = false;
            return false;
        }
        // if (!this.checkAndSetPhonenumber()) {
        //     this.registerClicked = false;
        //     return false;
        // }

        this.newUser.userName = this.email.value.toLowerCase();
        this.newUser.email = this.email.value.toLowerCase();
        this.newUser.gender = this.gender.value;
        this.newUser.title = this.title.value;
        // this.newUser.jobDescription = this.position.value;
        this.newUser.firstName = this.firstname.value;
        this.newUser.lastName = this.lastname.value;
        this.newUser.password = this.password.value;

        if (this.code) {
            this.registerWithCode();
        } else {
            this.registerWithoutCode();
        }
    }

    registerWithCode() {
        this.loading = true;
        this.registrationService
            .registerWithCode(this.newUser, this.code)
            .subscribe(
                (_) => {
                    // const modalResult = this.dialogService.openDialog(
                    //     'Email Bestätigung',
                    //     `Ein Bestätigungslink wurde an die E-Mail-Adresse ${this.newUser.userName} versandt. Überprüfen Sie Ihr Postfach und befolgen Sie die Anweisungen in der E-Mail.`
                    // );
                    // modalResult.subscribe((_) => {
                    //     this.router.navigate(['login']);
                    // });
                    this.router.navigate(['registry/confirmationlink']);
                },
                () => {
                    this.registerClicked = false;
                    this.loading = false;
                }
            );
    }

    registerWithoutCode() {
        this.loading = true;
        this.registrationService.register(this.newUser).subscribe({
            next: () => {
                this.router.navigate(['registry/confirmationlink']);
            },
            error: (err) => {
                this.registerClicked = false;
                this.loading = false;

                if (err?.status === 409) {
                    return;
                }

                const modalResult = this.dialogService.openDialog(
                    'Registrierung fehlgeschlagen',
                    'Während der Registrierung ist ein Fehler aufgetreten. Bitte versuchen Sie es später erneut.'
                );

                modalResult.subscribe(() => {
                    this.router.navigate(['/']);
                });
            }
        });
    }

    checkIfUserAlreadyInvited() {
        if (this.checkForInviteCode()) {
            this.registrationService
                .checkIfUserHasBeenInvited(this.inviteCode)
                .subscribe(
                    (userName) => {
                        this.registerWithInvite = true;
                        this.invitedUserName = userName;
                        this.registryForm.patchValue({
                            email: this.invitedUserName
                        });
                        this.registryForm.get('email').disable();
                    },
                    () => {
                        this.registerWithInvite = false;
                    }
                );
        } else {
            this.registryForm.patchValue({
                email: ''
            });
        }
    }

    checkForInviteCode(): boolean {
        // relativer check statt festgelegter substring?
        let result: boolean;
        let inviteCodePattern =
            /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/;
        let url = this.router.url;
        let submittedCode = url.substring(10, 46);
        if (submittedCode != '' && inviteCodePattern.test(submittedCode)) {
            this.inviteCode = submittedCode;
            result = true;
        } else {
            this.registerWithInvite = false;
            this.inviteCode = '';
            result = false;
        }
        return result;
    }

    ngOnInit() {
        this.checkIfUserAlreadyInvited();
        this.route.queryParams.subscribe((params) => {
            this.code = params['code'];

            if ('specialinvite' in params) {
                this.isSpecialInvite = params['specialinvite'] === 'true';
            } else {
                this.isSpecialInvite = null;
            }

            this.updateTerms3Validator();
        });
        this.headerService.loadHeaderText('BIMSWARM');

        this.routerSubscription = this.router.events
            .pipe(filter(event => event instanceof NavigationStart))
            .subscribe((event: NavigationStart) => {

                if (event.url.startsWith('/registry/confirmationlink')) {
                    this.shouldClearSelPackage = false;
                } else {
                    this.shouldClearSelPackage = true;
                }
            });
    }

    ngOnDestroy() {
        if (this.shouldClearSelPackage) {
            this.localSelectionService.clearSelection('selectedPackage-register');
        }

        if (this.routerSubscription) {
            this.routerSubscription.unsubscribe();
        }
    }

    private updateTerms3Validator(): void {
        const terms3Ctrl = this.registryForm.get('terms3Accepted');
        if (!terms3Ctrl) {
            return;
        }

        if (this.isSpecialInvite !== null) {
            terms3Ctrl.setValidators(Validators.requiredTrue);
        } else {
            terms3Ctrl.clearValidators();
            terms3Ctrl.setValue(false);
        }

        terms3Ctrl.updateValueAndValidity();
    }

    public onCancel(): void {
        this.router.navigate(['']);
    }


    checkPasswordStrength(password: string): void {
        this.passwordTouched = true;
        this.passwordCriteria.length = password.length >= 12;
        this.passwordCriteria.uppercase = /[A-Z]/.test(password);
        this.passwordCriteria.lowercase = /[a-z]/.test(password);
        this.passwordCriteria.number = /\d/.test(password);
        this.passwordCriteria.specialChar = /[\W_]/.test(password);
        this.passwordCriteria.noWhitespace = !/\s/.test(password);

        const passedRules = Object.values(this.passwordCriteria).filter(v => v).length;
        this.passwordStrength = passedRules;

        if (this.password) {
            this.password.setErrors(passedRules < 6 ? { invalidStrength: true } : null);
        }
    }

    getStrengthBarClass(barIndex: number): string {
        if (this.passwordStrength === 0 && !this.passwordTouched) return 'var(--app-warn)';

        if (this.passwordStrength < 3) {
            return barIndex <= 1 ? 'var(--app-warn) active' : 'var(--app-warn)';
        } else if (this.passwordStrength < 6) {
            return barIndex <= 2 ? 'var(--app-accent) active' : 'var(--app-accent)';
        } else {
            return 'var(--app-primary)';
        }
    }

    getStrengthLabel(): string {
        if (this.passwordStrength === 0 && !this.passwordTouched) return '';
        if (this.passwordStrength < 3) return 'Schwach';
        if (this.passwordStrength < 6) return 'Mittel';
        return 'Stark';
    }

    // TODO: if used in future, unify with ContactFormComponent.checkAndSetPhonenumber
    checkAndSetPhonenumber(): boolean {
        const phone = this.phoneNumber.value?.trim();

        if (!phone) {
            return true;
        }

        const isValid = this.utilService.validateInternationalPhone(phone);

        if (!isValid) {
            this.dialogService.openDialog(
                'Ungültige Telefonnummer',
                'Bitte geben Sie eine gültige Telefonnummer im internationalen Format ein (z. B. +49...).'
            );
            return false;
        }

        const phoneType = this.utilService.detectPhoneType(phone);

        if (phoneType === 'mobile') {
            this.newUser.mobileNumber = phone;
        } else if (phoneType === 'landline') {
            this.newUser.phoneNumber = phone;
        } else {
            this.newUser.phoneNumber = phone;
        }

        return true;
    }

    trimField(controlName: string) {
        const control = this.registryForm.get(controlName);
        if (control) {
            control.setValue(control.value?.trim());
        }
    }

}
